<template>
	<div class="principal">
		<NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
			:usarRelatorio="false" :usarRelatorioEstrela="true" :usarRelatorioEstrelaAtend="true" :usarFiltros="true"
			:usarFiltroSetor="true" :usarFiltroTpChamado="true" :usarFiltroPosicao="true" :usarFiltroPosicaoAuxiliar="true"
			:usarFiltroDatas="true" :nomeTela="'Quantidade de Atendimento ao Longo do Tempo'" :usarTrocaVisualizacao="true"
			:card="false" :tabela="true" :grafico="true" :visualizacaoPadrao="'Grafico'" @filtrar="filtrar()"
			:formatarDataInicioMes="formatarDataInicioMes" />

		<div class="mainDiv">
			<table class="table table-striped" v-show="this.tabela === 'Tabela'">
				<thead>
					<tr>
						<th>Dia</th>
						<th>Atendimentos</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(d, index) in this.dadosRelatorioTabelaOrdenado" :key="index">
						<td>{{ retornaDataFormatadaBr(d.data) }}</td>
						<td>{{ d.qtdeAtend }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div v-show="this.tabela === 'Grafico'">
			<div class="d-flex flex-column align-items-center">
				<canvas class="graficoRelatorio" id="graficoRelatorioAtendTempo"></canvas>
			</div>
		</div>
	</div>
	<ModalEditar :mostrar="this.mostrarModal" :modalLargo="true" :tamanhoModal="80">
		<template v-slot:header>
			<h2>Tempo Médio</h2>
		</template>
		<template v-slot:corpo>
			<Grid :dChamado="this.dadoModal" />
		</template>
		<template v-slot:rodape>
			<button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
		</template>
	</ModalEditar>
	<ModalEditar :mostrar="existeErro" :tamanhoModal="30">
		<template v-slot:header>
			{{ this.titulo }}
		</template>
		<template v-slot:corpo>
			{{ this.textoErro }}
		</template>
		<template v-slot:rodape>
			<button @click="desativarModal()" class="btn btn-primary">Entendi</button>
		</template>
	</ModalEditar>
</template>

<script>
import api from "@/api/api";
import store from "@/store/store";
import { Chart, CategoryScale, Title, LinearScale, LineController, LineElement, PointElement } from "chart.js";
import NavBar from "@/components/NavBar.vue";
import moment from "moment";
import ModalEditar from "@/components/ModalEditar.vue";
import Grid from "@/components/Grid.vue";

export default {
	name: "RelatorioAtendTempo",
	props: ["formatarDataInicioMes"],
	mounted() {
		Chart.register(CategoryScale, Title, LinearScale, LineController, LineElement, PointElement);
		this.filtrar(0, 0, 0, "FE", this.formatarDataInicioMes(new Date()), new Date(), this.tabela, "FE");
		// this.construirTabela(0, 0, "", this.formatarDataInicioMes(new Date()), new Date());
	},
	data() {
		return {
			dados: [],
			dadosRelatorioTabela: [],
			dadosRelatorioTabelaOrdenado: [],
			textoErro: String(),
			existeErro: Boolean(),
			titulo: String(),
			mostrarModal: Boolean(),
			grafico: null,
			dataUSA: [],
			lstTpChamado: [],
			valorFiltroSetor: Number(),
			valorFiltroTPChamado: Number(),
			tabela: "Grafico",
		};
	},
	methods: {
		retornaData(pData) {
			return new Date(pData);
		},

		async construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pValorFiltroPosicaoAuxiliar) {
			this.valorFiltroSetor = pValorFiltroSetor;
			this.valorFiltroTPChamado = pValorFiltroTPChamado;
			let sql = `SELECT
                       C.DATA, count(*)
                       FROM CHAMADO C
                       JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                       JOIN LEITO L ON L.ID = C.ID_LEITO 
                       JOIN QUARTO Q ON Q.ID = L.ID_QUARTO 
                       JOIN SETOR S ON S.ID = Q.ID_SETOR
					   `;
			if (this.retornaData(pDataInicial) > this.retornaData(pDataFinal)) {
				this.titulo = "Aviso";
				this.textoErro = "A Data Inicial não pode ser maior que a Data Final";
				this.existeErro = true;
			} else {
				let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
				let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");
				sql += `WHERE
						`;

				if (Number(pValorFiltroSetor) != 0) {
					sql += `S.ID = ${pValorFiltroSetor} AND 
						`;
				}

				if (Number(pValorFiltroTPChamado) != 0) {
					sql += `T.ID = ${pValorFiltroTPChamado} AND 
						`;
				}

				if (pValorFiltroPosicao.trim() != "") {
					sql += `(C.POSICAO = '${pValorFiltroPosicao}'`;
					if (pValorFiltroPosicaoAuxiliar.trim() != "") {
						sql += ` OR C.POSICAO = '${pValorFiltroPosicaoAuxiliar}'`;
					}
					sql += `) AND `;
				}

				sql += `
                        C.DATA BETWEEN '${auxDataInicial}' AND '${auxDataFinal}'
                        GROUP BY 1`;
				await api.listarSql(sql).then((resp) => {
					this.dadosRelatorioTabela = [];
					this.dadosRelatorioTabelaOrdenado = [];
					resp.forEach((r) => {
						this.dadosRelatorioTabela.push({ data: r[0], qtdeAtend: r[1] });
						this.dadosRelatorioTabelaOrdenado.unshift({
							data: r[0],
							qtdeAtend: r[1],
						});
					});
				});
			}
		},

		async construirGrafico() {
			const graficoRelatorioAtendTempo = document.getElementById("graficoRelatorioAtendTempo").getContext("2d");
			if (this.grafico) {
				this.grafico.destroy();
			}

			const hoverValue = {
				id: "hoverValue",
				afterDatasetsDraw(chart) {
					const { ctx, data, options } = chart;
					chart.getActiveElements().forEach((active) => {
						const value = data.datasets[active.datasetIndex].data[active.index];
						const fontSize = options.hoverRadius;
						ctx.save();
						ctx.textAlign = "center";
						ctx.font = `bold ${fontSize}px sans-serif`;
						ctx.lineDashOffset = 10;
						ctx.fillText(value, active.element.x, active.element.y);
						ctx.restore();
					});
				},
			};

			let dia = [];
			let qtdeAtend = [];
			this.dataUSA = [];

			this.dadosRelatorioTabela.forEach((d) => {
				dia.push(this.retornaDataFormatadaBr(d.data));
				this.dataUSA.push(this.retornaDataFormatadaUSA(d.data));
				qtdeAtend.push(d.qtdeAtend);
			});

			if (this.dadosRelatorioTabela.length > 0) {
				this.grafico = new Chart(graficoRelatorioAtendTempo, {
					type: "line",
					data: {
						labels: dia,
						datasets: [
							{
								label: qtdeAtend, //
								data: qtdeAtend, // Valor do tempo médio
								backgroundColor: ["rgb(255, 255, 255)"],
								borderColor: ["rgb(55, 255, 55)"],
							},
						],
					},
					options: {
						hoverRadius: 20,
						plugins: {
							title: {
								display: true,
								text: "Atendimento ao Longo do Tempo",
								padding: {
									top: 10,
									bottom: 30,
								},
								font: {
									size: 20,
								},
							},
						},
						onClick: async (e, active) => {
							let data = `'${this.dataUSA[active[0].index]}' and '${this.dataUSA[active[0].index]}'`;
							await api.filtrarDados("", this.valorFiltroTPChamado, this.valorFiltroSetor, 0, 0, "desc", "desc", data)
								.then((resposta) => {
									let aux = [];
									aux = resposta;
									for (let i = 0; i < aux.length; i++) {
										for (let j = 0; j < aux.length - i - 1; j++) {
											if (aux[j].id < aux[j + 1].id) {
												let temp = aux[j];
												aux[j] = aux[j + 1];
												aux[j + 1] = temp;
											}
										}
									}
									this.dadoModal = aux;
								});
							this.mostrarModal = true;
						},
					},
					plugins: [hoverValue],
				});
			}
		},

		async filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao, pValorFiltroPosicaoAuxiliar) {
			this.tabela = pVisualizacao;
			await this.construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pValorFiltroPosicaoAuxiliar);
			if (this.tabela === "Grafico") {
				this.construirGrafico();
			}
		},

		retornaDataFormatadaBr(pData) {
			return moment(pData).format("DD/MM/YYYY");
		},

		retornaDataFormatadaUSA(pData) {
			return moment(pData).format("MM/DD/YYYY");
		},

		converterHora(pSegundos) {
			let horaFinal = "", auxDia = 0, auxHora = 0, auxMinuto = 0, auxSegundo = pSegundos;

			while (auxSegundo >= 60) {
				auxMinuto++;
				auxSegundo = auxSegundo - 60;
			}

			while (auxMinuto >= 60) {
				auxHora++;
				auxMinuto -= 60;
			}

			while (auxHora >= 24) {
				auxDia++;
				auxHora -= 24;
			}

			if (auxDia > 0) {
				horaFinal += auxDia + "d ";
			}

			if (auxHora > 0) {
				horaFinal += auxHora + "h ";
			}

			if (auxMinuto > 0) {
				horaFinal += auxMinuto + "m ";
			}

			if (Number(auxSegundo).toFixed(0) > 0) {
				horaFinal += Number(auxSegundo).toFixed(0) + "s ";
			}

			return horaFinal;
		},

		deslogar() {
			sessionStorage.removeItem("TokenReguaPainel");
			this.$router.back();
		},

		desativarModal() {
			this.existeErro = false;
		},

		fecharModal() {
			this.dadoModal = [];
			this.mostrarModal = false;
		},
	},
	computed: {
		setores() {
			return store.state.setores;
		},
		config() {
			return store.state.config;
		},
		tipoChamado() {
			return store.state.tipoChamado;
		},
	},
	components: {
		NavBar,
		ModalEditar,
		Grid,
	},
};
</script>

<style scoped></style>
